(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	function initStickyAtc() {
		const stickyAtc = document.querySelector("[data-sticky-atc]");
		const mainAtc = document.querySelector("product-form button[type='submit']");
		let variantRadios = document.querySelector("variant-radios");

		if (!stickyAtc || !mainAtc) return;

		window.addEventListener("scroll", function () {
			// Function to check if the main ATC is visible
			const observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
						if (entry.isIntersecting) {
							stickyAtc.style.display = "none";
						} else if (entry.intersectionRatio === 0) {
							// Only show the sticky ATC if we're scrolled past the button
							if (entry.boundingClientRect.top < 0) {
								stickyAtc.style.display = "flex";
								if(window.innerWidth >= 1024) {
									stickyAtc.style.left = (entry.boundingClientRect.right - entry.boundingClientRect.width) + "px";
								}
							} else {
								// Hide the sticky ATC when viewport is above the button
								stickyAtc.style.display = "none";
							}
						}
				});
			}, { threshold: 0.1 });

			observer.observe(mainAtc);
		});

		const stickyAtcButton = stickyAtc.querySelector("button");

		// Click event to trigger the main ATC button
		stickyAtcButton.addEventListener("click", () => {
			stickyAtcButton.classList.add('loading');
			stickyAtc.querySelector('.loading-overlay__spinner').classList.remove("hidden");
			mainAtc.click();

			setTimeout(() => {
				stickyAtc.querySelector('.loading-overlay__spinner').classList.add("hidden");
				stickyAtcButton.classList.remove('loading');
				stickyAtcButton.blur();
			}, 1500);
		});

		if(variantRadios) {
			const inputs = variantRadios.querySelectorAll("input[type='radio']");
			stickyAtc.querySelector("variant-selects").addEventListener("change", (e) => {
				inputs.forEach(radio => {
					if(radio.value === e.target.value) {
						radio.checked = true;
					}
				});
			});
		}
	}

	function initVideoAutoPlay() {
		const mediaSlider = document.querySelector('.js-media-list');
		if (!mediaSlider) return;

		
		const autoplayEnabled = mediaSlider.getAttribute('data-video-autoplay') === 'true';
		if (!autoplayEnabled) return;

		const checkSwiper = setInterval(() => {
			if (mediaSlider.swiper) {
				clearInterval(checkSwiper);
				autoplayActiveVideo(mediaSlider.swiper);

				mediaSlider.swiper.on('slideChange', function() {
					autoplayActiveVideo(this);
				});
			}
		}, 100);
	}

	function autoplayActiveVideo(swiperInstance) {
		const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
		if (!activeSlide) return;

		const deferredMedia = activeSlide.querySelector('deferred-media');
		if (deferredMedia) {
			const posterButton = deferredMedia.querySelector('.deferred-media__poster');
			const video = deferredMedia.querySelector('video');
			const iframe = deferredMedia.querySelector('iframe');

			
			if (deferredMedia.getAttribute('loaded')) {
				if (video) {
					video.currentTime = 0;  
					video.play();
				} else if (iframe) {
					
					iframe.contentWindow.postMessage('{"event":"command","func":"seekTo","args":[0, true]}', '*');
					iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
				}
			}
			
			else if (posterButton) {
				posterButton.click();
			}
		}

		
		document.querySelectorAll('.js-media-list deferred-media').forEach(media => {
			if (media !== deferredMedia) {
				const video = media.querySelector('video');
				const iframe = media.querySelector('iframe');
				if (video) video.pause();
				if (iframe) {
					
					iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
				}
			}
		});
	}

	document.addEventListener('DOMContentLoaded', function() {
		initVideoAutoPlay();
	});

	document.addEventListener('shopify:section:load', function(event) {
		initVideoAutoPlay();
	});


	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initStickyAtc();
	});

	initProductAccordion();
	initStickyAtc();
})();
